import "@dotlottie/player-component";
import jsonlink from "./ylaunch_1.json";
const BannerPlayer = () => {
	console.log(jsonlink);
	return (
		<div className="App">
			<dotlottie-player
				src="https://lottie.host/a33b2f67-46d4-4db7-9b2d-454815a130cf/4U1z3Umshy.json"
				autoplay
				loop
				mode="client"
			/>
		</div>
	);
};

export default BannerPlayer;
